import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";




const ContactUs = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(

                "service_2tgflge",
                "template_nwb3d8q",
                "#myForm",
                "ieg4RjjBNF3wSvoaX"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Contact Us</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Contact Us</li>
                    </ul>
                </div>
            </section>

            <section className="contact-page-section-two" style={{ marginTop: "-60px" }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="map-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <div className="map-outer">
                                    <div className="embed-map-responsive"><div className="embed-map-container"><iframe className="embed-map-frame" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=500&height=500&hl=en&q=Satna%20Swastik%20Hospital%20&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://sprunkiretake.net" style={{ fontSize: '2px!important', color: 'gray!important', position: 'absolute', bottom: 0, left: 0, zIndex: 1, maxHeight: 1, overflow: 'hidden' }}>sprunki retake</a></div><style dangerouslySetInnerHTML={{ __html: ".embed-map-responsive{position:relative;text-align:right;width:100%;height:0;padding-bottom:100%;}.embed-map-container{overflow:hidden;background:none!important;width:100%;height:100%;position:absolute;top:0;left:0;}.embed-map-frame{width:100%!important;height:100%!important;position:absolute;top:0;left:0;}" }} /></div>
                                </div>
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                        </div>

                        <div className="info-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <ul className="info">
                                    <li><span>Email</span> <a href="mailto:satnaswastikhospital@gmail.com" style={{ color: "black" }}>satnaswastikhospital@gmail.com</a></li>
                                    <li><span>Phone number</span>
                                        <a href='tel: +91 7672326319' style={{ color: "black" }}>+91 7672326319</a> <br />
                                        <a href='tel: +91 7509182172' style={{ color: "black" }}>+91 7509182172</a>
                                    </li>
                                    <li><span>Office Address</span><a href='https://share.google/Ekv0nUxkNaGImU8TX' target="_blank" style={{ color: "black" }}>सतना स्वास्तिक हॉस्पिटल पन्नीलाल चौक, सतना (म.प्र.)</a></li>
                                    {/* <li><span>Send us mail</span>To discuss us about work with us <br /> you can contact us.</li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="contact-form-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="form-column col-lg-7 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <h3>Fill in your details and we’ll call you back</h3>
                                <div className="default-form contact-form">
                                    <form method="post" action="sendemail.php" id="contact-form" noValidate="novalidate">
                                        <div className="row clearfix">
                                            <div className="col-lg-4 col-md-6 col-sm-12 form-group">
                                                <input type="text" name="username" placeholder="Name" required />
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 form-group">
                                                <input type="text" name="email" placeholder="Email" required />
                                            </div>
                                            <div className="col-lg-4 col-md-12 col-sm-12 form-group">
                                                <input type="text" name="phone" placeholder="Phone" required />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                <textarea className name="message" placeholder="Your text here..." defaultValue={""} />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                <button className="theme-btn btn-style-one">
                                                    <span className="btn-wrap">
                                                        <Link to="/">
                                                            <span className="text-one">Contact Us</span>
                                                            <span className="text-two">Contact Us</span>
                                                        </Link>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="image-column col-lg-5 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <div className="image wow fadeInRight animated" data-wow-delay="0ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'fadeInRight' }}>
                                    <img src="assets/images/resource/doctor.png" alt />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}





        </>
    )
}

export default ContactUs